module.exports = __webpack_public_path__ + "static/media/21.490cd073.png";